import type { Column, RowData, TableFeatures } from '@tanstack/react-table';

/**
 * Gets the header's display value.
 * @param column - The column object.
 * @returns the label of the column header: string if available, or the label if it's a custom header; otherwise falls back to the column id.
 * @internal
 */
export function getColumnLabel(column: Column<TableFeatures, RowData>): string {
  const { header, label } = column.columnDef;
  if (typeof header === 'string') {
    return header;
  }
  return label ?? column.id;
}
